import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogModule} from '@angular/material/dialog';
import {TextButton} from '../../components/text-button/text-button.component';
import {FormsModule} from '@angular/forms';
import {TranslocoPipe} from '@jsverse/transloco';
import {MatIconModule} from '@angular/material/icon';

// The button closes it through `mat-dialog-close` rather than `dialogRef.close()`, which would hand
// focus back to the button that triggered the failed request as "program" focus and leave it
// highlighted. The directive tells Material whether the click came from a mouse or a keyboard.
@Component({
  selector: 'app-error',
  imports: [MatDialogModule, TextButton, FormsModule, MatIconModule, TranslocoPipe],
  templateUrl: './error.dialog.html',
  styleUrl: './error.dialog.scss'
})
export class ErrorDialog {
  constructor(@Inject(MAT_DIALOG_DATA) public data: { title: string, message: string }) {
  }
}
